import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { i18n } from '../../language';
import { initValue } from '../../utils';
import Img from './Img';
import File from './File';

const useStyles = makeStyles((theme) => ({
  imgs: {
    width: '100%',
    margin: '1.875rem 0 1.875rem -0.75rem',
  },
  img: {
    width: '100%',
    height: 'auto',
    borderRadius: '0.625rem',
  },
  fileTitle: {
    marginTop: '1.875rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.35px',
    fontWeight: '500',
  },
  file: {
    height: '3.125rem',
    minWidth: '16.563rem',
    margin: '0.938rem 0.938rem 0 0',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    paddingRight: '1rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  box: {
    width: '1.875rem',
    height: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0.625rem',
  },
  docIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: theme.palette.primary.main,
  },
}));

export default function FileCom({ imgData, fileData, type, onAllImagesLoaded }) {
  const classes = useStyles();

  return (
    <>
      {imgData.length > 0 && (
        <Grid className={classes.imgs} container spacing={3}>
          {imgData.map((item, index) => {
            return (
              <Grid item sm={6} lg={4} xl={3} key={initValue(item?.DOWNLOAD_URL, item)}>
                <Img id={item} url={item?.DOWNLOAD_URL} type={type} onLoad={onAllImagesLoaded} />
              </Grid>
            );
          })}
        </Grid>
      )}
      {fileData.length > 0 && (
        <div
          style={{
            marginBottom: '1.25rem',
          }}
        >
          <div className={classes.fileTitle}>{`${i18n.t('EHANDOVER_NOTE_ATTACHMENT')}`}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {fileData.map((item, index) => {
              return (
                <File
                  id={item}
                  key={initValue(item?.DOWNLOAD_URL, item)}
                  type={type}
                  url={item?.DOWNLOAD_URL}
                  name={item?.NAME}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
